var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in"}},[_c('keep-alive',{attrs:{"max":20,"exclude":"login,Resigter,Experiment,gateway"}},[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }